import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { OrgService } from 'app/modules/admin/core/org/org.service';
import { MatSelect } from '@angular/material/select';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Usr } from 'app/modules/admin/core/usr/usr.model';
import { ThemeService } from 'app/custom-component/theme.service';
import { ROLES } from 'app/shared/constraints/roles.constants';

@Component({
    selector: 'modern-layout',
    templateUrl: './modern.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ModernLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: any;
    // navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    navigationAppearance: 'default' | 'dense' = 'dense';
    sidebarNavigation: any[];
    navigationData: any;
    selected;
    orgList;
    map = new Map<any, any>();
    orgView: boolean = false;
    userRole: string;
    pltf: string
    //onboarding tour variable

    showOnboarding = false;
    _userData: Usr;
    currentPopupIndex: number = 0;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _httpClient: HttpClient,
        private themeService: ThemeService
    ) {

        this.pltf = sessionStorage.getItem('pltf');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.userRole = sessionStorage.getItem('activeRole');
    }



    toggleNavigation(name: string): void {
        // Get the navigation
        console.warn("out in")
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            console.warn("in")
            // Toggle the opened status
            navigation.toggle();
            this.sidebarNavigation = this.navigation;
            console.warn(this.sidebarNavigation)
        }
    }

    toggleNavigationAppearance(ele): void {
        this.navigationAppearance = (this.navigationAppearance === 'default' ? 'dense' : 'default');
    }

    redirectToHome() {
        const activeRole = sessionStorage.getItem('activeRole');
        if (activeRole == ROLES.CUSTOMER) {
            this._router.navigate(['/dashboards/project']);
        } else if (activeRole == ROLES.AGENT) {
            this._router.navigate(['/svc/svcReq/agn-dash']);
        } else if (activeRole == ROLES.BUS_OPS_ADMIN) {
            this._router.navigate(['/svc/svcReq/agn-dash']);
        }
    }

    redirectToLstVw() {
        const activeRole = sessionStorage.getItem('activeRole');
        if (activeRole == ROLES.CUSTOMER) {
            this._router.navigate(['/svc/svcReq/lst-vw']);
        } else if (activeRole == ROLES.AGENT) {
            this._router.navigate(['/svc/svcReq/csul-svc-list']);
        } else if (activeRole == ROLES.BUS_OPS_ADMIN) {
            this._router.navigate(['/svc/svcReq/csul-svc-list']);
        }
    }

    click($event) {
        console.log($event);
    }

    isDarkTheme() {
        return this.themeService.isDark();
    }

    logout() {
        sessionStorage.clear();
        this._router.navigate(['/sign-in']);
    }

    isBusOpsAdmin(): boolean {
        return this.userRole === ROLES.BUS_OPS_ADMIN;  //ROLES.BUS_OPS_ADMIN;
    }

    /**
 * On destroy
 */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

}
